import React from 'react';
import { Link } from 'react-router-dom';
import { Waves, Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img
                src="/logo.jpg"
                alt="Streamline Aquatics"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="text-slate-400 leading-relaxed">
              Building confidence, one stroke at a time. Ghana's premier swimming education and competitive training facility.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/schedules-pricing" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Schedules & Pricing
                </Link>
              </li>
              <li>
                <Link to="/book-lesson" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Book a Lesson
                </Link>
              </li>
              <li>
                <Link to="/swim-team" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Marlins Swim Team
                </Link>
              </li>
              <li>
                <Link to="/policies" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Policies
                </Link>
              </li>
              <li>
                <Link to="/partnerships" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  School Partnerships
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Mail className="w-5 h-5 text-cyan-400 mt-0.5" />
                <span className="text-slate-400">info@streamlineaquatics.co</span>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="w-5 h-5 text-cyan-400 mt-0.5" />
                <span className="text-slate-400">+233 20 135 8015</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 text-cyan-400 mt-0.5" />
                <a 
                  href="https://maps.app.goo.gl/bc5BJSq3SDxWW35d8?g_st=ac"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-cyan-400"
                >
                  Achimota Swimming & Leisure Center
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors"
                data-testid="facebook-link"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors"
                data-testid="instagram-link"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors"
                data-testid="twitter-link"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
            <p className="text-slate-400 mt-6 text-sm">
              Join our community and stay updated with the latest news and events.
            </p>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Streamline Aquatics Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
